import React, {useState, useEffect} from 'react';
import { Layout, Menu, Breadcrumb, Input } from 'antd';
import {Col,Row, Form, Button} from 'react-bootstrap';
import { Segment } from 'semantic-ui-react';
import './Demo.css';
import {formatBaseStr, spellConfirm, numberVerify, getSeqArrayInfo} from './Common.js';
import SideMenu from './SideMenu';

const { SubMenu } = Menu;
const { Header, Content, Footer, Sider } = Layout;
const { TextArea } = Input;

export default function Tool03() {

    const [sequence, setSequence] = useState("");
    const [count, setCount] = useState("");
    const [length, setLength] = useState("");
    const [result, setResult] = useState([]);

    function handleSequence(e){
        let current = e.target.value;
        // console.log(current);
        setSequence(current);
    }
    
    function handleCount(e){
        let current = e.target.value;
        // console.log(current);
        setCount(current);
    }

    function handleLength(e){
        let current = e.target.value;
        setLength(current);
    }

    function handleSubmit(){
            var perStrLength = length; //每段长度
			var overlopNum = count;
			var allStr = sequence;
			if (overlopNum == '')
				overlopNum = 0;

			//初始化

			formatBaseStr(allStr);
			if (allStr == ''){
                return null;
            }
			var result1 = '';
			var listStr = new Array(); //存储序列结果
			//传入字符串&定义每段字符串长度
			var strLength = allStr.toString().length; //总长度
			var startIndex = 0; //位置标记(下次开始位置)
			//字符串循环加入列表
			startIndex = parseInt(startIndex);
			strLength = parseInt(strLength);
			perStrLength = parseInt(perStrLength);
			//拼写检查

			if (!(spellConfirm(allStr) && numberVerify(perStrLength) && (perStrLength <= allStr.length) && (overlopNum <= allStr.length))) {
				alert("输入格式错误");
				console.log('input error');
				return null;
			};
            if (overlopNum > perStrLength || overlopNum > strLength) {
				alert("输入格式错误");
				return null;
			}

			//当折叠长度为0时
			if (overlopNum == 0) {

				for (var i = 0; i < parseInt(strLength / perStrLength); i++) {
					listStr.push(allStr.substring(startIndex, startIndex + perStrLength));
					startIndex = startIndex + perStrLength;
				}
				//处理最后一段
				listStr.push(allStr.toString().substring(startIndex, strLength));
				if (listStr[listStr.length - 1] == '')
					listStr.pop();
				//得到完整的序列数组listStr
				// console.log(listStr)
				result1 = getSeqArrayInfo(listStr);
			}

			//当折叠长度不为0时

			/*下次起始位置为：结束位置+减去折叠长度
              总生成个数：总长/（单位长度-折叠长度）
				*/
			else {
				var seqNum = parseInt(strLength / (perStrLength - overlopNum));
				for (var i = 0; i < seqNum; i++) {
					listStr.push(allStr.substring(startIndex, startIndex + perStrLength));
					//更改下次开始位置
					startIndex = startIndex + perStrLength - overlopNum;
				}
				//处理最后一段
				listStr.push(allStr.toString().substring(startIndex, strLength));
				if (listStr[listStr.length - 1] == '')
					listStr.pop();
				//得到完整的序列数组listStr
				// console.log(listStr)
				result1 = getSeqArrayInfo(listStr);
			}
			console.log(listStr);
			while (listStr[listStr.length - 1].length != perStrLength)
				listStr.pop()
			console.log(listStr);
			// document.getElementById("demo").innerHTML = listStr;
            setResult(listStr)
    }

    return (

        <Layout style={{height: "100vh"}}>
            <Header className="header" style={{minHeight: "5vh"}}>
                <div style={{fontSize:"2rem",color:"white"}}>BioTools</div>
            </Header>
            <Content style={{ padding: '5vh 50px', minHeight: "80vh",maxHeight:"80vh"}}>
            {/* <Breadcrumb style={{ margin: '16px 0' }}>
                <Breadcrumb.Item style={{fontSize:"1.5rem"}}>Tools 01</Breadcrumb.Item>
            </Breadcrumb> */}
            <Layout className="site-layout-background" >
                <Sider className="site-layout-background" width={200}>
                    <SideMenu params={["3"]} />
                </Sider>
                <Content style={{ background:"white", minHeight: "75vh",maxHeight:"75vh" }}>
                    <Segment basic style={{height:"100%"}} >
                        <Segment style={{height:"100%"}} >
                            <Row>
                                <Col sm={1} />
                                <Col>
                                    <Form>
                                        <div style={{height:"1rem"}} />
                                        <Form.Group className="mb-3" controlId="formBasicEmail">
                                            <Form.Label size="lg">序列</Form.Label>
                                            <TextArea
                                                // value={value}
                                                onChange={handleSequence}
                                                // placeholder="Controlled autosize"
                                                autoSize={{ minRows: 3, maxRows: 5 }}
                                            />
                                        </Form.Group>
                                        <div style={{height:"1rem"}} />
                                        <Form.Group className="mb-3" controlId="formBasicEmail">
                                            <Form.Label size="lg">Overlop数目</Form.Label>
                                            <Form.Control type="number" onChange={handleCount}  />
                                            
                                        </Form.Group>
                                        <div style={{height:"1rem"}} />

                                        <Form.Group className="mb-3" controlId="formBasicEmail">
                                            <Form.Label size="lg">分割长度</Form.Label>
                                            <Form.Control type="number" onChange={handleLength}  />
                                            
                                        </Form.Group>
                                        <div style={{height:"1rem"}} />

                                        <Button onClick={handleSubmit}>提交</Button>

                                        <div style={{height:"3rem"}} />

                                        <Form.Group className="mb-3" controlId="formBasicEmail">
                                            <Form.Label size="lg">结果</Form.Label>
                                            <TextArea
                                                value={result.toString().replaceAll(",","\n")}
                                                // placeholder="Controlled autosize"
                                                autoSize={{ maxRows: 5 }}
                                                // disabled
                                                bordered={false}
                                            />
                                            {/* <div id="demo"></div> */}
                                            
                                            
                                        </Form.Group>
                                        <div style={{height:"1rem"}} />
                                    </Form>
                                </Col>
                                <Col sm={1} />
                            </Row>
                        </Segment>
                    </Segment>
                </Content>
            </Layout>
            </Content>
            <Footer style={{ textAlign: 'center',minHeight: "10vh" }}>TIB ©2021 Created by Biodesign Center</Footer>
        </Layout>
    )
}
